export default "__VITE_ASSET__D8MV1PcX__"